// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-button{padding:1rem 1.333rem;background-color:#003d4c;color:#fff;display:inline-block}.form-button[disabled]{background-color:#e3e3e3}.form-button--dark{background-color:#000}.form-button--invert{background-color:transparent;border:2px solid #003d4c;color:#003d4c}", ""]);
// Exports
module.exports = exports;
